import {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";

import {filteringAction} from "../features/sliceReducer/projectListReducer";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../features/store";

//import model
import {regionList} from "../models/commonData";

import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import {Box, Button} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginLeft: "16px",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

type projectFilterType = {
  year: number;
  grade: number;
  region: number;
};

interface SelectBoxProps {
  filterChangeHandler?: any;
}

const SelectBox = (props: SelectBoxProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {filtering} = useSelector((state: RootState) => state.projectList);
  const {
    handleSubmit,
    control,
    watch,
    reset,
    formState: {errors},
  } = useForm<projectFilterType>({defaultValues: filtering});

  const onSubmit = handleSubmit<projectFilterType>((filter) =>
    reset({year: 9999, region: 9999, grade: 9999})
  );
  // const onSubmit = handleSubmit<projectFilterType>((filter) =>
  //   dispatch(filteringAction({year: 9999, region: 9999, grade: 9999}))
  // );

  let currentYear = new Date().getFullYear();
  const yearList: number[] = [];
  for (let i = currentYear; i >= 2018; i--) {
    yearList.push(i);
  }

  const {year, region, grade} = watch();

  useEffect(() => {
    dispatch(filteringAction({year, region, grade}));
    if (props.filterChangeHandler !== undefined) {
      props.filterChangeHandler();
    }
  }, [year, region, grade]);

  return (
    <form onSubmit={onSubmit}>
      <Box display="flex" alignItems="center">
        <FormControl className={classes.formControl}>
          <InputLabel id="year">작성년도</InputLabel>
          <Controller
            name="year"
            control={control}
            defaultValue={filtering.year}
            render={({field}) => (
              <Select {...field} labelId="year" id="year" label="작성년도">
                <MenuItem selected value={9999}>
                  전체연도
                </MenuItem>
                {yearList?.map((year, index) => (
                  <MenuItem key={index} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="grade">현재등급</InputLabel>
          <Controller
            name="grade"
            control={control}
            defaultValue={filtering.grade}
            render={({field}) => (
              <Select {...field} labelId="grade" id="grade" label="현재등급">
                <MenuItem selected value={9999}>
                  전체등급
                </MenuItem>
                <MenuItem value={0}>P</MenuItem>
                <MenuItem value={1}>S</MenuItem>
                <MenuItem value={2}>M+</MenuItem>
                <MenuItem value={3}>M-</MenuItem>
              </Select>
            )}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="region">지역</InputLabel>
          <Controller
            name="region"
            control={control}
            defaultValue={filtering.region}
            render={({field}) => (
              <Select {...field} labelId="region" id="region" label="지역">
                <MenuItem selected value={9999}>
                  전체지역
                </MenuItem>
                {regionList.map((region, index) => (
                  <MenuItem key={index} value={index}>
                    {region}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </FormControl>
        <Box textAlign="center" ml={2} pt={2}>
          <Button variant="outlined" color="secondary" onClick={onSubmit}>
            reset
          </Button>
        </Box>
      </Box>
    </form>
  );
};
export default SelectBox;
